var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-sidebar",attrs:{"data-pages":"sidebar"}},[_c('div',{staticClass:"sidebar-overlay-slide from-top",attrs:{"id":"appMenu"}}),_vm._v(" "),_c('sidebar-header'),_vm._v(" "),_c('sidebar-menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7facec38","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Sidebar/Sidebar.vue
// module id = 1958
// module chunks = 0